export const NewsletterData = {
  message1: 'STAY CONNECTED',
  message2: 'To Stay in the loop about the newest deals.',
  Status: ['Student', 'Teacher', 'Other'],
}
